import { useQuery } from '@tanstack/react-query';
import { keys } from '@/api/queryKeys';
import { settingsApi } from '../api/settingsApi';

export function useProviders(includeInactive = false) {
  return useQuery({
    queryKey: [...keys.settings.providers, includeInactive],
    queryFn: ({ signal }) => settingsApi.getProviders(includeInactive, { signal }),
    staleTime: 300_000,
  });
}
